/**
 * Returns a valid money formatted string for the value, and shortens it.
 * Example: 5000 => $5k
 *
 * @param x - The value to format
 * @param currency - gives the currency format
 */
export default function formatShortMoney(
  x: number | string,
  currency = '$',
): string {
  let treatedNumber: number;
  let accessory = '';
  if (typeof x === 'number') {
    treatedNumber = x;
  } else {
    treatedNumber = parseInt(x, 10);
  }

  if (treatedNumber >= 1000) {
    treatedNumber /= 1000;
    accessory = 'k';
  }

  return `${currency}${Math.round(treatedNumber)}${accessory}`;
}
